import Options from 'trunks/vue/share/components/options.js';
import CheckBoxMixin from 'trunks/vue/share/components/fields/check_box.js';
import LogicalCheckBoxMixin from 'trunks/vue/share/mixins/logic_field/check_box.js';
import FieldMixinForResponse from './mixin.js';
import OptionsMultipleSelect from 'trunks/vue/admin/components/options_multiple_select.js';

const CheckBoxForResponse = {
  components: {
    'Options': Options,
    'options-multiple-select': OptionsMultipleSelect
  },

  mixins: [
    FieldMixinForResponse,
    CheckBoxMixin,
    LogicalCheckBoxMixin
  ],

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <options-multiple-select
          v-if="optionsClass === 'select'"
          :initialSelectedOptions='value'
          :options='field.options'
          :otherOption='otherOption'
          :multiple='true'
          @valueChange='valueChange'
          ref='optionsSelectRef'
        />
        <div
          v-else
          class="form-field-value"
          :class="{ 'readonly': !editing }"
        >
          <Options :initialSelectedOptions='value'
                   :options='field.options'
                   :multiple=true
                   :otherOption='otherOption'
                   :disabled='!editing'
                   :optionsClass='optionsClass'
                   ref='optionsView'
                   @valueChange='valueChange' />
        </div>
      </template>
    </Field>
  `,

  computed: {
    optionsClass: function() {
      return this.field.settings.layout;
    }
  }
};

export default CheckBoxForResponse;
